/*
 * Copyright (c) 2026 GS Elektromedizinische Geraete G. Stemple GmbH, Germany - all rights reserved.
 * <p>
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 */

import { Divider, List, Typography } from '@mui/material';
import style from './PatientEducation.scss?inline';
import { Fragment, useContext, useState } from 'react';
import PatientEducationDialog from './PatientEducationDialog';
import PatientEducationButton from './PatientEducationButton';
import { useCSS } from '../../../provider/CSSProvider';
import { ConfirmationEvent } from '../../../models/manualEvents/confirmationEvent';
import { ReportsAPIContext } from '../../../provider/ReportsAPIProvider';
import { NodeType } from '../../../backendModels/report.model';
import { MANUAL_EVENT_RECORD_ELEMENT_KEY, ManualEventRecord } from '../../../models/genericElements/events/manualEvent';
import { confirmationEventDetails } from '../../../config/patientEducationTexts';

function PatientEducation() {
  useCSS(style);

  const [dialogOpen, setDialogOpen] = useState(false);
  const [confirmationLabel, setConfirmationLabel] = useState<ConfirmationEvent>();
  const { findMultipleRecords } = useContext(ReportsAPIContext);

  function handleOpenDialog(eventLabel: ConfirmationEvent) {
    setConfirmationLabel(eventLabel);
    setDialogOpen(true);
  }

  const eventRecords = findMultipleRecords(
    'generic',
    NodeType.GENERIC,
    MANUAL_EVENT_RECORD_ELEMENT_KEY
  ) as ManualEventRecord[];

  const namesOfPresentEvents = eventRecords.map((record) => record.values?.eventName?.text);

  return (
    <div id='PatientEducation'>
      <Typography id='patient-education-header'>Patientenaufklärung</Typography>

      <PatientEducationDialog open={dialogOpen} onOpenChanged={setDialogOpen} label={confirmationLabel} />

      <List className='patient-education-button-list'>
        {Object.values(ConfirmationEvent).map((eventLabel, index) => (
          <Fragment key={index}>
            <PatientEducationButton
              label={eventLabel}
              isConfirmed={namesOfPresentEvents.includes(confirmationEventDetails[eventLabel].title)}
              handleClick={() => handleOpenDialog(eventLabel)}
            />
            {index < Object.values(ConfirmationEvent).length - 1 && <Divider component='li' variant='middle' />}
          </Fragment>
        ))}
      </List>
    </div>
  );
}

export default PatientEducation;
